import { CIcon } from '~/icons/types'

export const ciBin: CIcon = {
  width: '20',
  height: '20',
  paths: [
    {
      d:
        'M15.844 2.422h-2.512v-.64c0-.977-.797-1.774-1.773-1.774H8.44c-.976 0-1.773.797-1.773 1.773v.64H4.156c-.976 0-1.773.798-1.773 1.774v1.168c0 .336.27.606.605.606h.223l1.004 12.039a2.166 2.166 0 0 0 2.156 1.984h7.262a2.161 2.161 0 0 0 2.156-1.984l1.004-12.04h.223a.603.603 0 0 0 .605-.605V4.195a1.783 1.783 0 0 0-1.777-1.773Zm-7.965-.64c0-.313.254-.563.562-.563h3.118c.312 0 .562.254.562.562v.64H7.88v-.64ZM3.594 4.194c0-.312.254-.562.562-.562h11.688c.312 0 .562.254.562.562v.563H3.594v-.563ZM14.582 17.91a.959.959 0 0 1-.95.875h-7.26a.956.956 0 0 1-.95-.875L4.426 5.97h11.148l-.992 11.941Z'
    },
    {
      d:
        'M10 16.879c.336 0 .605-.27.605-.606V8.48A.604.604 0 0 0 10 7.875a.603.603 0 0 0-.605.605v7.793c0 .332.27.606.605.606Zm2.488-.004h.047a.605.605 0 0 0 .602-.558l.586-7.794a.607.607 0 0 0-.559-.648.607.607 0 0 0-.648.559l-.586 7.793a.602.602 0 0 0 .558.648Zm-5.625-.558c.024.316.29.558.602.558h.047a.607.607 0 0 0 .558-.648l-.586-7.793a.607.607 0 0 0-.648-.559.607.607 0 0 0-.559.648l.586 7.794Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'bin',
  type: 'regular'
}
